import * as React from 'react'
import {useSafeEffect} from '@freckle/react-hooks'
import {addMaybeClassName} from '@freckle/student-materials/src/helpers/classnames'
import {type HeadingProps} from './heading-props'
import {h3} from './typography.module.scss'

type Props = HeadingProps

export default function H3(props: Props): React.ReactElement<Props> {
  const {children, isFocused = false, id, addClass, dataTest, role, ariaLabel} = props
  const className = addMaybeClassName(h3, addClass)
  const headingRef = React.useRef<HTMLElement>(undefined)
  useSafeEffect(() => {
    if (isFocused && headingRef.current) {
      headingRef.current.tabIndex = -1
      headingRef.current.focus()
    }
  }, [isFocused])
  return React.createElement(
    props.as ?? 'h3',
    {
      id,
      className,
      'data-test': dataTest,
      'aria-label': ariaLabel,
      role,
      ref: headingRef
    },

    children
  )
}
